import { resolvePath } from '@/utils/resolvePath';
import Lottie from 'lottie-react';
import loaderCar from 'public/animations/loader-car.json';
interface ILoaderProps {
    imagePathname?: string;
    loaderText?: string;
    size?: number;
}
const CustomLoader = (props: ILoaderProps) => {
    const {
        imagePathname = '/images/loader-main.gif',
        loaderText = 'Taking you to your next destination...',
        size = 160,
    } = props;
    return (
        <div>
            <div className="loader">
                <Lottie
                    animationData={loaderCar}
                    loop={true}
                    style={{ width: `${size}px`, height: `${size}px` }}
                />
                {/* <img
                    src={resolvePath(imagePathname)}
                    width={'120px'}
                    height={`120px`}
                    alt="success"
                    className="loader-image"
                /> */}
                {loaderText && <div className="info">{loaderText}</div>}
            </div>
            <style jsx>{`
                .loader {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    position: fixed;
                    left: 0;
                    top: 0;
                    height: 100vh;
                    width: 100vw;
                    background: #fff;
                    z-index: 1;
                }
                .info {
                    width: 280px;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                }
            `}</style>
        </div>
    );
};

export default CustomLoader;
